import { useState, useEffect, useMemo } from 'react';
import { Center, ChakraProvider, Spinner } from '@chakra-ui/react';
import { useGetConfig } from '@/services/queries/admin-config';
import { theme } from '@/styles/theme';
import tinycolor from 'tinycolor2';

const DynamicThemeProvider = ({ children }) => {
  const [colors, setColors] = useState<any | undefined>(undefined);
  const { data, isLoading } = useGetConfig();

  // Atualiza as cores com base nos dados da API
  useEffect(() => {
    if (data?.colors?.primary) {
      const primaryColor = data.colors.primary;
      const baseColor = tinycolor(primaryColor);

      const shades = {
        50: tinycolor.mix(baseColor, 'white', 80).toHexString(), // 80% branco
        100: tinycolor.mix(baseColor, 'white', 60).toHexString(), // 60% branco
        200: tinycolor.mix(baseColor, 'white', 40).toHexString(), // 40% branco
        300: tinycolor.mix(baseColor, 'white', 20).toHexString(), // 20% branco
        400: baseColor.lighten(10).toHexString(), // Clarear um pouco
        500: baseColor.toHexString(), // Cor original
        600: baseColor.darken(10).toHexString(), // Escurecer um pouco
        700: tinycolor.mix(baseColor, 'black', 20).toHexString(), // 20% preto
        800: tinycolor.mix(baseColor, 'black', 40).toHexString(), // 40% preto
        900: tinycolor.mix(baseColor, 'black', 60).toHexString(), // 60% preto
      };

      setColors(shades);
    }
  }, [data]);

  // Cria um novo tema baseado nas cores dinâmicas
  const newTheme = useMemo(() => {
    if (colors) {
      return theme(colors); // Presume que a função `theme` aceita cores dinâmicas
    }
    return theme(); // Retorna o tema padrão se `colors` ainda não estiver definido
  }, [colors]);
  if (isLoading || !colors)
    return (
      <div style={{ backgroundColor: 'white !important', position: 'relative' }}>
        <Center position='fixed' top='0' left='0' right='0' bottom='0' backgroundColor='rgb(255, 255, 255)' zIndex='9999'>
          <Spinner style={{ padding: '20px' }} size='xl' color='gray.500' emptyColor='#ffff' />
        </Center>
      </div>
    );

  return (
    <ChakraProvider theme={newTheme} toastOptions={{ defaultOptions: { position: 'top-right' } }}>
      {children}
    </ChakraProvider>
  );
};

export default DynamicThemeProvider;
